import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { getReviewStats, getBusinessStats } from '@/services/reviewStats.js'

const isActive = b => {
    if (b.enabled === false) return false
    const now = new Date()
    if (b.activeFrom && new Date(b.activeFrom) > now) return false
    if (b.activeTo   && new Date(b.activeTo)   < now) return false
    return true
}

const shuffle = arr => {
    const a = [...arr]
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]]
    }
    return a
}

define('FeaturedBusinesses', () => {
    const root = h('section', { className: 'featured-biz' })

    Promise.all([
        fetch(`/data/businesses.json?t=${Date.now()}`).then(r => r.json()),
        getReviewStats()
    ]).then(([data, stats]) => {
            const gold = (data.items || []).filter(b => isActive(b) && b.plan === 'oro')
            if (!gold.length) return

            gold.forEach(b => {
                const s = getBusinessStats(stats, b.id)
                b._reviewAvg   = s.avg
                b._reviewCount = s.count
            })
            const dest    = gold.filter(b => b.destacado)
            const rest    = gold.filter(b => !b.destacado)
            const rated   = rest.filter(b => b._reviewAvg > 0).sort((a, b) => b._reviewAvg - a._reviewAvg || b._reviewCount - a._reviewCount)
            const unrated = shuffle(rest.filter(b => !b._reviewAvg))
            const items = [...shuffle(dest), ...rated, ...unrated].slice(0, 8)

            const track = h('div', { className: 'featured-biz__track' })
            items.forEach(item => track.appendChild(c('BusinessCard', item)))

            let dragging = false, didDrag = false, startX = 0, scrollLeft = 0
            track.addEventListener('mousedown', e => {
                dragging = true
                didDrag = false
                startX = e.clientX
                scrollLeft = track.scrollLeft
                track.style.scrollBehavior = 'auto'
            })
            track.addEventListener('mousemove', e => {
                if (!dragging) return
                if (Math.abs(e.clientX - startX) > 5) didDrag = true
                if (!didDrag) return
                e.preventDefault()
                track.style.cursor = 'grabbing'
                track.scrollLeft = scrollLeft - (e.clientX - startX)
            })
            track.addEventListener('click', e => {
                if (didDrag) e.preventDefault()
            }, true)
            const endDrag = () => {
                if (!dragging) return
                dragging = false
                track.style.cursor = ''
                track.style.scrollBehavior = ''
            }
            track.addEventListener('mouseup', endDrag)
            track.addEventListener('mouseleave', endDrag)

            const prev = h('button', { className: 'carousel-arrow carousel-arrow--prev', type: 'button' }, '‹')
            const next = h('button', { className: 'carousel-arrow carousel-arrow--next', type: 'button' }, '›')

            prev.addEventListener('click', () => {
                track.scrollBy({ left: -track.offsetWidth * 0.8, behavior: 'smooth' })
            })
            next.addEventListener('click', () => {
                track.scrollBy({ left: track.offsetWidth * 0.8, behavior: 'smooth' })
            })

            const wrapper = h('div', { className: 'carousel-wrap' }, prev, track, next)

            root.appendChild(
                h('div', { className: 'featured-biz__inner' },
                    h('div', { className: 'featured-biz__header' },
                        h('h2', { className: 'featured-biz__title' }, 'Negocios destacados'),
                        h('a',  { className: 'featured-biz__see-all', href: '/directorio' }, 'Ver directorio →')
                    ),
                    wrapper
                )
            )
        })
        .catch(() => {})

    return root
})
